import Template from "@/components/Dashboard/Dashboard.template.vue";
import { App, Service } from "@/interfaces/roles";
import { User } from "@/vuex/auth/types";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  mixins: [Template]
})
export default class Dashboard extends Vue {
  @Getter("user", { namespace: "authModule" }) public user!: User;
  @Getter("services", { namespace: "authModule" })
  public services!: Service[];
  public apps: App[] = [
    {
      title: "biotrack",
      image: require("@/assets/images/app_brand_bioTrackTHC.svg"),
      path: process.env.VUE_APP_DISPENSARY_FRONT,
      app: "bdi"
    },
    {
      title: "cannalytics",
      image: require("@/assets/images/app_brand_cannalytics.svg"),
      path:
        process.env.VUE_APP_CANNALYTICS_FRONT ||
        "https://apps.helixcannalytics.com/accounts/user_login/",
      app: "cnl"
    }
  ];

  public goTo(route: string) {
    if (route) {
      window.location.href = route;
    }
  }

  public get items(): object[] {
    const items = [];
    const myApps: string[] = ["cnb", "cnl"];
    this.services.forEach(service => myApps.push(String(service.id)));
    for (const app of this.apps) {
      if (myApps.includes(app.app)) {
        if (app.app !== "core") {
          items.push({ ...app, isLive: true });
        }
      } else {
        items.push({ ...app, isLive: false });
      }
    }
    return items;
  }
}
